
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/Model'
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class datiFumo extends Vue {

    @Prop() value: OM.CalcoliFumo;
    @Prop() readonly: boolean;

}
